import { useEffect, useState } from 'react';

import { requestStatus, responseStatus } from '../shared/statuses';

export enum ExchangeTypes {
  Fetching,
  Creating,
  Updating,
  Removing,
}

const isPending = (type: ExchangeTypes, reqStatus: number) => {
  switch (type) {
    case ExchangeTypes.Fetching:
      return reqStatus === requestStatus.FETCHING || reqStatus === requestStatus.FETCHING_LIST;
    case ExchangeTypes.Creating:
      return reqStatus === requestStatus.CREATING;
    case ExchangeTypes.Updating:
      return reqStatus === requestStatus.UPDATING;
    case ExchangeTypes.Removing:
      return reqStatus === requestStatus.REMOVING;
  }

  return false;
};

interface InitalState {
  type: ExchangeTypes;
  pending: boolean;
  successful: boolean;
  failed: boolean;
}

export const initialExchangeStatus = (type: ExchangeTypes, reqStatus: number): InitalState => ({
  type,
  pending: reqStatus !== null ? isPending(type, reqStatus) : false,
  successful: false,
  failed: false,
});

const withDataExchangeStatusEffect = (
  currentStatus: InitalState,
  callback: (state: InitalState) => void,
  reqStatus: number,
  respStatus: number,
) => {
  useEffect(() => {
    const { type, pending, successful, failed } = currentStatus;

    if (!isPending(type, reqStatus) && (successful || failed)) {
      return;
    }

    if (pending && respStatus === responseStatus.OK) {
      callback({ type, pending: false, successful: true, failed: false });
    }
    if (pending && respStatus === responseStatus.FAILED) {
      callback({ type, pending: false, successful: false, failed: true });
    }
    if (isPending(type, reqStatus)) {
      callback({ type, pending: true, successful: false, failed: false });
    }
  }, [reqStatus, respStatus]);
};

export const useDataExchangeStatus = (type: ExchangeTypes, httpStatuses: number[]) => {
  if (httpStatuses.length !== 2) {
    throw new Error(
      "Both request status and response status need to be applied to 'useDataExchangeStatus'",
    );
  }

  const [status, setStatus] = useState(() => initialExchangeStatus(type, httpStatuses[0]));

  withDataExchangeStatusEffect(status, setStatus, httpStatuses[0], httpStatuses[1]);
  return status;
};
